import React from 'react';
import isArray from 'lodash/isArray';
import isString from 'lodash/isString';
import Data from '../data';
import RateAdvisorUtil from './RateAdvisorUtil';
import ServiceOptionsIncluded from './ServiceOptionsIncluded.component';

const { PackageType } = Data;

// serviceData
const ServiceInfo = props => {
	const { serviceData } = props;
	const { packageDescription, packageRequirements } = serviceData;
	const includedServices = RateAdvisorUtil.getIncludedServiceOptions(serviceData);
	let title = 'Packaging Requirements:';

	if (serviceData.packageType === PackageType.Postcard) {
		title = 'Postcard Requirements:';
	} else if (
		serviceData.packageType === PackageType.Letter ||
		serviceData.packageType === PackageType.LargeEnvelope
	) {
		title = 'Envelope Requirements';
	}

	return (
		<div className="common-rate-advisor-service-info">
			<div className="left-panel">
				{isString(packageDescription) && (
					<div className="description">
						<h4 className="title">More Info:</h4>

						{/* eslint-disable-next-line */}
						<p dangerouslySetInnerHTML={{ __html: packageDescription }} />
					</div>
				)}
				{isArray(packageRequirements) && (
					<div className="description">
						<h4 className="title">{title}</h4>
						{packageRequirements.map((requirement, index) => (
							/* eslint-disable-next-line */
							<p key={index} dangerouslySetInnerHTML={{ __html: requirement }} />
						))}
					</div>
				)}
			</div>
			<div className="right-panel">
				<h4 className="title">Includes:</h4>
				<ServiceOptionsIncluded iconSize="normal" data={includedServices} />
			</div>
		</div>
	);
};

export default ServiceInfo;
